<div class="d-flex mb-3 mt-3 justify-space-between">
  <div>
    <img alt="back" class="cursor" (click)="handleBack()" src="../../../../assets/images/arrow_circle_left.svg" />&nbsp;
    <span class="geo-title">Geo Trace - Playback
      History</span>
  </div>
</div>

<div class="playback-container">
  <div class="dashboard-container">
    <div class="box map-box d-grid position-relative">
      <!-- <img src="../../../../assets/images/collaps-geotrace.svg"
        *ngIf="!isloader && masterMapData?.length && !isCollapsed" class="position-absolute cursor" alt="expand"
        style="top: 10px; right: 10px; z-index: 9999;" (click)="expandMap()" />
      <img src="../../../../assets/images/collapse-geotrace.svg"
        *ngIf="!isloader && masterMapData?.length && isCollapsed" class="position-absolute cursor" alt="expand"
        style="top: 10px; right: 10px; z-index: 9999;" (click)="expandMap()" /> -->
      <div *ngIf="!isloader" class="info-header position-absolute" style="top: 12px; left: 30px; z-index: 9999;">
        <div class="info-item" *ngFor="let alert of alertTypes">
          <div class="d-flex gap-10">
            <div>
              <img [src]="derivedAlerts[alert.key] ? 
                '../../../../assets/images/Derived-active-alert.svg' : 
                '../../../../assets/images/Alert-playback.svg'" alt="alert" />
            </div>
            <div>{{ alert.displayName }}</div>
          </div>
        </div>
      </div>
      <app-moving-marker [trip]="isMapAnalyticsEnabled ? hereMappedCoordinatesArray : telemetryCoordinatesArray" [tunnelBridgeData]="tunnelBridgeData" [trafficSignals]="trafficSignals" [segmentDetails]="segmentDetails" [showAiAssist]="showAiAssist" [tripAssistPlots]="tripAssistPlots" [highlightedSegment]="highlightedSegment"
      [mapEvents]="mapEvents" [optimizedRouteData]="optimizedRouteData" [selectedAlertIndex]="selectedAlertIndex" (playbackStateUpdate)="updatePlayback($event)" (isPlaying)="isPlaying = $event" [apiKey]="apiKey" [styleUrl]="hereMapStyleUrl" [telemetryAlertCoordinates]="telemetryAlertCoordinates"></app-moving-marker>
    </div>
  </div>

  <div class="right-container" *ngIf="!isAnalysisDrawerOpen">
    <app-trip-history [type]="'playbackV2'" [entityDetails]="entityDetails" [entityId]="entityId" [date]="selectedDate" [aggregateDate]="aggregateDate" [transformedAttributeData]="transformedAttributeData"
      [pageType]="'geoPlayback'" [isCollapsed]="isCollapsed" [entityName]="entityDetails?.uniqueId" [tripId]="tripId"
      [tripName]="tripName" (aiAssistDetails)="updateAiAssistDetails($event)" (highlightedTripSegment)="highlightedTripSegment($event)" (analysisDrawerOpen)="switchAnalysisDrawer($event)"></app-trip-history>
    <div class="map-controls">
      <div class="playback-v2-map-controls-label">Map Controls</div>
      <form [formGroup]="analyticsForm" class="analytics-controls">
        <div *ngFor="let parent of mapControlsList" class="toggle-group-container">

          <div class="toggle-item parent-item">
            <div class="toggle-label">{{ parent.label }}</div>
            <mat-slide-toggle [formControlName]="parent.key" color="primary"
              (change)="performAction(parent.key, $event.checked)">
            </mat-slide-toggle>
          </div>

          <div *ngIf="parent.isParent && parent.children && analyticsForm.get(parent.key)?.value && !isloader"
            class="child-toggles-container">
            <div *ngFor="let child of parent.children" class="toggle-item child-item">
              <div class="toggle-label">{{ child.label }}</div>
              <mat-slide-toggle [formControlName]="child.key" color="primary"
                (change)="performAction(child.key, $event.checked)">
              </mat-slide-toggle>
            </div>
          </div>
        </div>
      </form>
    </div>
    </div>
  <div>
    <app-playback-analysis-drawer  *ngIf="isAnalysisDrawerOpen" [entityId]="entityId" [transformedAttributeData]="transformedAttributeData" [chartTypes]="chartTypes" [alertsHighlighted]="alertsHighlighted" [chartSelectedDate]="chartSelectedDate"
     [date]="selectedDate" [aggregateDate]="aggregateDate" [selectedDate]="selectedDate" [telemetryTableData]="telemetryTableData" [isOpen]="isAnalysisDrawerOpen" [entityName]="entityDetails?.uniqueId"
     (selectedAlert)="selectedAlert($event)" (closeDrawer)="switchAnalysisDrawer(false)">
    </app-playback-analysis-drawer>
  </div>
</div>